// The Light Room Home : tiroir panier (modèle Asterford). S'ouvre à chaque ajout au panier,
// quelle que soit son origine (formulaire du thème, ajout rapide, cross-sell, ampoule) et au clic sur le sac.
(() => {
  const root = document.querySelector('[data-tlr-cart]');
  if (!root || window.__tlrCart) return;
  window.__tlrCart = true;
  const $ = s => root.querySelector(s), $$ = s => [...root.querySelectorAll(s)];
  const money = c => '£' + (c / 100).toFixed(2);
  const esc = s => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const xsell = (() => { try { return JSON.parse($('[data-cart-xsell]').textContent); } catch (e) { return []; } })();
  xsell.forEach(p => p.variants = p.variants.filter(Boolean));
  let cart = null, busy = false;

  const nativeFetch = window.fetch.bind(window);
  const getCart = async () => (cart = await (await nativeFetch('/cart.js', { headers: { Accept: 'application/json' } })).json());

  function open() {
    root.hidden = false;
    void root.offsetWidth; // force le rendu fermé avant d'animer l'ouverture
    root.classList.add('is-open');
    document.documentElement.classList.add('tlr-cart-open');
  }
  function close() {
    root.classList.remove('is-open'); document.documentElement.classList.remove('tlr-cart-open');
    setTimeout(() => { if (!root.classList.contains('is-open')) root.hidden = true; }, 320);
  }
  root.addEventListener('click', e => { if (e.target.closest('[data-cart-close]')) close(); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && !root.hidden) close(); });

  // lampes comptées pour l'offre (les ampoules ne comptent pas)
  const lights = c => c.items.filter(i => !/bulb/i.test(i.product_type + ' ' + i.product_title)).reduce((n, i) => n + i.quantity, 0);

  function renderOffer() {
    const q = lights(cart), d = root.dataset;
    let txt, pct;
    const fill = (t, k) => t.replace('#', k).replace(/(light|lamp)(?!s)/, k > 1 ? '$1s' : '$1');
    if (q < 2) { txt = fill(d.offerStep1, 2 - q); pct = q / 3 * 100; }
    else if (q < 3) { txt = fill(d.offerStep2, 3 - q); pct = 66.6; }
    else { txt = d.offerDone; pct = 100; }
    $('[data-cart-offer]').innerHTML = esc(txt).replace(/(\d+% off)/g, '<b>$1</b>');
    $('[data-cart-bar]').style.width = pct + '%';
    $('[data-cart-l1]').textContent = d.label1; $('[data-cart-l2]').textContent = d.label2;
  }

  // Shopify scinde une même variante en deux lignes quand la remise ne porte que sur une unité
  // (« 2nd light 20% off ») : on les regroupe pour n'afficher qu'une ligne, quantité et prix cumulés.
  const groups = () => {
    const g = [];
    cart.items.forEach(it => {
      let x = g.find(y => y.variant_id === it.variant_id && JSON.stringify(y.properties || {}) === JSON.stringify(it.properties || {}));
      if (!x) g.push(x = { ...it, quantity: 0, final_line_price: 0, original_line_price: 0, keys: [], titles: [] });
      x.quantity += it.quantity; x.final_line_price += it.final_line_price; x.original_line_price += it.original_line_price;
      x.keys.push({ key: it.key, quantity: it.quantity });
      (it.line_level_discount_allocations || []).forEach(a => x.titles.includes(a.discount_application.title) || x.titles.push(a.discount_application.title));
    });
    return g;
  };
  let shown = [];

  function renderItems() {
    shown = groups();
    $('[data-cart-items]').innerHTML = shown.map((it, i) => {
      const opts = (it.options_with_values || []).filter(o => !/default title/i.test(o.value)).map(o => `<span>${esc(o.name)} : ${esc(o.value)}</span>`).join('');
      const disc = it.titles.map(t => `<span class="tlr-cart__badge">${esc(t)}</span>`).join('');
      const was = it.original_line_price > it.final_line_price ? `<s>${money(it.original_line_price)}</s>` : '';
      const img = it.featured_image && it.featured_image.url ? it.featured_image.url + (it.featured_image.url.includes('?') ? '&' : '?') + 'width=200' : '';
      return `<div class="tlr-cart__item" data-g="${i}">
        <a class="tlr-cart__img" href="${esc(it.url)}">${img ? `<img src="${esc(img)}" alt="${esc(it.product_title)}" loading="lazy">` : ''}</a>
        <div class="tlr-cart__info"><a class="tlr-cart__name" href="${esc(it.url)}">${esc(it.product_title)}</a>
          <div class="tlr-cart__price">${was}<span>${money(it.final_line_price)}</span></div>
          <div class="tlr-cart__opts">${opts}</div>${disc ? `<div class="tlr-cart__discs">${disc}</div>` : ''}</div>
        <div class="tlr-cart__act">
          <button type="button" class="tlr-cart__del" data-del aria-label="Remove ${esc(it.product_title)}"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"/></svg></button>
          <div class="tlr-cart__qty"><button type="button" data-q="-1" aria-label="One less">−</button><span>${it.quantity}</span><button type="button" data-q="1" aria-label="One more">+</button></div>
        </div></div>`;
    }).join('');
  }

  // suggestions : d'abord une 2e unité de ce qui est déjà au panier (la paire), puis les best-sellers absents
  function renderXsell() {
    const inCart = new Set(cart.items.map(i => i.handle));
    const pairs = cart.items.filter(i => !/bulb/i.test(i.product_type)).map(i => xsell.find(p => p.handle === i.handle) || {
      handle: i.handle, title: i.product_title, url: i.url, image: i.featured_image && i.featured_image.url, variants: [{ id: i.variant_id, title: i.variant_title || '', price: i.final_price === i.price ? i.price : i.original_price, image: '' }] });
    const rest = xsell.filter(p => !inCart.has(p.handle));
    const list = [...pairs, ...rest].filter((p, k, a) => a.findIndex(x => x.handle === p.handle) === k && p.variants.length).slice(0, 5);
    const wrap = $('[data-cart-xs-wrap]');
    wrap.hidden = !list.length;
    $('[data-cart-xs-title]').innerHTML = root.dataset.xsellTitle;
    $('[data-cart-xs]').innerHTML = list.map(p => {
      const v0 = p.variants[0], multi = p.variants.length > 1 && !(p.variants.length === 1);
      const img = (v0.image || p.image || '');
      return `<div class="tlr-cart__xc" data-xc>
        <a class="tlr-cart__xi" href="${esc(p.url)}">${img ? `<img src="${esc(img)}" alt="" loading="lazy">` : ''}</a>
        <div class="tlr-cart__xb"><a class="tlr-cart__xn" href="${esc(p.url)}">${esc(p.title)}</a><span class="tlr-cart__xp" data-xp>${money(v0.price)}</span>
          <div class="tlr-cart__xr">${multi ? `<select data-xv aria-label="Option">${p.variants.map(v => `<option value="${v.id}" data-price="${v.price}" data-img="${esc(v.image || '')}">${esc(v.title)}</option>`).join('')}</select>` : `<input type="hidden" data-xv value="${v0.id}">`}
          <button type="button" class="tlr-cart__add" data-xadd>Add</button></div></div></div>`;
    }).join('');
    $('[data-cart-dots]').innerHTML = list.length > 1 ? list.map((_, k) => `<button type="button" aria-label="Suggestion ${k + 1}" data-dot="${k}"${k ? '' : ' class="on"'}></button>`).join('') : '';
  }

  function renderTotals() {
    $('[data-cart-n]').textContent = cart.item_count;
    $('[data-cart-total]').textContent = money(cart.total_price);
    const saved = cart.original_total_price - cart.total_price;
    $('[data-cart-save]').hidden = saved <= 0; $('[data-cart-save-v]').textContent = '−' + money(saved);
    const codes = (cart.discount_codes || []).filter(d => d.applicable);
    $('[data-cart-codes]').innerHTML = codes.map(d => `<span class="tlr-cart__badge">${esc(d.code)} <button type="button" data-uncode="${esc(d.code)}" aria-label="Remove code">×</button></span>`).join('');
    document.querySelectorAll('[data-tlr-count]').forEach(x => x.textContent = cart.item_count);
  }

  function render() {
    root.classList.toggle('is-empty', !cart.item_count);
    renderOffer(); renderItems(); renderXsell(); renderTotals();
  }
  const refresh = async () => { await getCart(); render(); };

  const post = (url, body) => nativeFetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
  // + ajoute une unité de la variante, − retire une unité de la dernière ligne du groupe, la poubelle vide tout le groupe
  async function changeGroup(g, delta) {
    if (busy) return; busy = true; root.classList.add('is-busy');
    try {
      if (delta === 0) await post('/cart/update.js', { updates: Object.fromEntries(g.keys.map(k => [k.key, 0])) });
      else if (delta > 0) await post('/cart/add.js', { items: [{ id: g.variant_id, quantity: 1, properties: g.properties || {} }] });
      else { const last = g.keys[g.keys.length - 1]; await post('/cart/change.js', { id: last.key, quantity: last.quantity - 1 }); }
      await refresh();
    } finally { busy = false; root.classList.remove('is-busy'); }
  }
  root.addEventListener('click', async e => {
    const item = e.target.closest('[data-g]'), g = item && shown[+item.dataset.g];
    if (g && e.target.closest('[data-del]')) return changeGroup(g, 0);
    const q = e.target.closest('[data-q]');
    if (g && q) return changeGroup(g, +q.dataset.q);
    const add = e.target.closest('[data-xadd]');
    if (add) {
      const card = add.closest('[data-xc]'), id = +card.querySelector('[data-xv]').value;
      add.disabled = true; add.textContent = '…';
      await nativeFetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id, quantity: 1 }] }) });
      await refresh(); return;
    }
    const dot = e.target.closest('[data-dot]');
    if (dot) { const tr = $('[data-cart-xs]'); tr.scrollTo({ left: tr.clientWidth * +dot.dataset.dot, behavior: 'smooth' }); }
    const un = e.target.closest('[data-uncode]');
    if (un) { const keep = (cart.discount_codes || []).map(d => d.code).filter(c => c !== un.dataset.uncode).join(','); await nativeFetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: keep }) }); refresh(); }
  });
  root.addEventListener('change', e => {
    const sel = e.target.closest('[data-xv]'); if (!sel || sel.tagName !== 'SELECT') return;
    const o = sel.selectedOptions[0], card = sel.closest('[data-xc]');
    card.querySelector('[data-xp]').textContent = money(+o.dataset.price);
    if (o.dataset.img) card.querySelector('.tlr-cart__xi img').src = o.dataset.img;
  });
  $('[data-cart-xs]').addEventListener('scroll', e => {
    const tr = e.currentTarget, k = Math.round(tr.scrollLeft / tr.clientWidth);
    $$('[data-dot]').forEach((d, i) => d.classList.toggle('on', i === k));
  }, { passive: true });
  $('[data-cart-code]').addEventListener('submit', async e => {
    e.preventDefault();
    const code = e.target.code.value.trim(); if (!code) return;
    const all = [...new Set([...(cart.discount_codes || []).map(d => d.code), code])].join(',');
    await nativeFetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: all }) });
    e.target.code.value = ''; await refresh();
    if (!(cart.discount_codes || []).some(d => d.code.toLowerCase() === code.toLowerCase() && d.applicable))
      $('[data-cart-codes]').insertAdjacentHTML('beforeend', `<span class="tlr-cart__err">${esc(code)} is not valid for this cart</span>`);
  });

  // ouverture à chaque ajout au panier, d'où qu'il vienne
  let t;
  const afterAdd = () => { clearTimeout(t); t = setTimeout(async () => {
    document.querySelector('.tlr-qa:not([hidden])') && document.querySelector('.tlr-qa [data-qa-close]')?.click();
    await refresh(); open(); }, 150); };
  window.fetch = async function (input, init) {
    const res = await nativeFetch(input, init);
    try {
      const url = typeof input === 'string' ? input : input.url;
      if (/\/cart\/add(\.js)?(\?|$)/.test(url) && res.ok) afterAdd();
    } catch (e) {}
    return res;
  };
  document.addEventListener('cart:update', () => { if (root.hidden) afterAdd(); else refresh(); });

  // le sac de l'en-tête ouvre le tiroir au lieu de la page panier
  document.addEventListener('click', e => {
    const bag = e.target.closest('.tlr-hdr .bag, a[href$="/cart"]');
    if (!bag || e.target.closest('[data-tlr-cart]') || e.metaKey || e.ctrlKey) return;
    e.preventDefault(); refresh().then(open);
  }, true);
  window.TLRCart = { open: () => refresh().then(open), close, refresh };
})();
